export default __webpack_public_path__ + "static/Blender-Thin-690e84a514d27faabff439e815561b28.woff2";